import { http } from '../http';

const BASEURL = '/api/ai-hotline';

/** Mirrors AiHotlineSettingsDto: operator-editable settings read by the bot at call time */
export interface AiHotlineSettings {
  /** E.164 number the call is handed to when the caller asks for a human; empty = unavailable */
  transferPhoneNumber: string;
  /** seconds the officer's phone rings before the caller is told nobody is available */
  transferTimeoutSeconds: number;
  /** spoken to the officer before the two legs are bridged */
  transferWhisper: string;
  /** contractors a bulky item removal case can be dispatched to */
  contractors: string[];
  /** Take over button only: the officer phone, or the operator's browser (caller-requested transfers always use the phone) */
  takeoverTarget?: 'phone' | 'browser';
  /** voice of the AI agent from the next call on; each maps to one fixed OpenAI voice in the bot */
  agentVoice?: 'male' | 'female';
}

export interface VoiceToken {
  /** Twilio Client identity the browser registers as */
  identity: string;
  token: string;
  ttlSeconds: number;
}

/** Twilio Voice access token for answering taken-over calls in this browser */
export const getVoiceToken = async () => {
  return await http.get(`${BASEURL}/voice-token`);
};

export const getAiHotlineSettings = async () => {
  return await http.get(`${BASEURL}/settings`);
};

export const saveAiHotlineSettings = async (params: AiHotlineSettings) => {
  return await http.put(`${BASEURL}/settings`, params);
};
